var React = require('react');

function IconShare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M757.97 629.497c-33.366 0-63.919 11.3-88.459 30.165L416.405 507.818c1.212-7.76 2.085-15.713 2.085-23.812 0-8.147-.873-16.053-2.085-23.812L669.511 308.35c24.54 18.865 55.093 30.165 88.459 30.165 80.311 0 145.491-65.131 145.491-145.491S838.281 47.533 757.97 47.533s-145.491 65.131-145.491 145.491c0 8.099.873 16.053 2.134 23.812L361.507 368.728c-24.539-18.915-55.141-30.214-88.507-30.214-80.36 0-145.491 65.131-145.491 145.491 0 80.311 65.131 145.491 145.491 145.491 33.366 0 63.968-11.3 88.507-30.165l253.106 151.844c-1.261 7.76-2.134 15.664-2.134 23.812 0 80.311 65.18 145.491 145.491 145.491s145.491-65.18 145.491-145.491-65.18-145.49-145.491-145.49z"}));
}

IconShare.displayName = "IconShare";

IconShare.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconShare;

IconShare.default = IconShare;
